// src/utils/axios.js
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:31000',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  // Remove withCredentials if you're using JWT tokens (not cookies)
  withCredentials: true, // Comment this out if you're using JWT tokens instead of cookies
});

// Add request interceptor for auth token
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Ensure token is properly formatted
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Log request for debugging
    // console.log('Request details:', {
    //   url: config.url,
    //   method: config.method,
    //   hasToken: !!token,
    //   authorization: config.headers.Authorization ? 'Present' : 'Missing'
    // });
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Response error:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      config: {
        url: error.config?.url,
        method: error.config?.method,
        headers: error.config?.headers
      }
    });
    
    // Handle 401 unauthorized
    if (error.response?.status === 401) {
      // Clear all auth data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userData');
      
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/portal/login?returnUrl=${returnUrl}`;
      }
      
      const event = new CustomEvent('unauthorized', { 
        detail: { message: 'Session expired' } 
      });
      window.dispatchEvent(event);
    }
    return Promise.reject(error);
  }
);

export default instance;